module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-works"
  }, [_c('section', {
    staticClass: "content-works"
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageWork.header_text) ? _c('div', {
    staticClass: "text-center headline-container"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.pageWork.header_text.value))]), _vm._v(" "), (_vm.pageWork.intro_paragraph) ? _c('p', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "intro_text"
  }, [_vm._v("\n          " + _vm._s(_vm.pageWork.intro_paragraph.value) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "toggle-filter",
    class: {
      isOpen: _vm.showSelect
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropSelect()
      }
    }
  }, [_vm._v("\n        FILTER\n      ")]), _vm._v(" "), (_vm.showSelect || !this.$breakpoints.isMobile()) ? _c('div', {
    staticClass: "filter-container container-fluid"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "select-container selectSolutions",
    class: {
      isOpen: _vm.visibleSolutions
    }
  }, [_c('dropdown', {
    attrs: {
      "visible": _vm.visibleSolutions,
      "position": _vm.position,
      "animation": 'ani-fade'
    },
    on: {
      "clickOut": function($event) {
        _vm.visibleSolutions = false
      }
    }
  }, [_c('span', {
    staticClass: "select gtm_Solutions-Filter",
    on: {
      "click": function($event) {
        _vm.visibleSolutions = !_vm.visibleSolutions;
        _vm.visibleMarkets = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedSolutionTitle))]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('li', {
    attrs: {
      "value": "",
      "title": 'All Solutions'
    },
    on: {
      "click": function($event) {
        return _vm.filterBy('solution', $event)
      }
    }
  }, [_vm._v("\n                  All Solutions\n                ")]), _vm._v(" "), _vm._l((_vm.taxonomySolutions), function(option, index) {
    return [(option.codename != 'inclusion') ? _c('li', {
      key: index,
      attrs: {
        "title": option.name,
        "value": '&elements.solutions__for_work_[all]=' + option.codename,
        "codename": option.codename
      },
      on: {
        "click": function($event) {
          return _vm.filterBy('solution', $event)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")]) : _vm._e()]
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "select-container selectMarkets",
    class: {
      isOpen: _vm.visibleMarkets
    }
  }, [_c('dropdown', {
    attrs: {
      "visible": _vm.visibleMarkets,
      "position": _vm.position,
      "animation": 'ani-fade'
    },
    on: {
      "clickOut": function($event) {
        _vm.visibleMarkets = false
      }
    }
  }, [_c('span', {
    staticClass: "select gtm_Markets-Filter",
    on: {
      "click": function($event) {
        _vm.visibleMarkets = !_vm.visibleMarkets;
        _vm.visibleSolutions = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedMarketTitle))]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('li', {
    attrs: {
      "value": "",
      "title": 'All Markets'
    },
    on: {
      "click": function($event) {
        return _vm.filterBy('market', $event)
      }
    }
  }, [_vm._v("\n                  All Markets\n                ")]), _vm._v(" "), _vm._l((_vm.taxonomyMarkets), function(option, index) {
    return _c('li', {
      key: index,
      attrs: {
        "title": option.name,
        "value": '&elements.market_categories[all]=' + option.codename,
        "codename": option.codename
      },
      on: {
        "click": function($event) {
          return _vm.filterBy('market', $event)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "gtm_Search",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "dist/search-icon.svg",
      "alt": "Search Icon"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('boxes-wrapper', {
    attrs: {
      "boxes": _vm.filteredWorks,
      "modularContent": _vm.modularContent,
      "search": _vm.search,
      "boxlimit": 8
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b6ebd4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Works.vue
// module id = 1511
// module chunks = 0